import { jsx as _jsx } from "react/jsx-runtime";
import { DinTestPage } from '@/pages/din-test-page.component';
import ResultCategoryPage, { ResultCategoryOutlet, } from '@/pages/result-category/components/result-category-page.component';
import { AgeStep, ConnectHeadphoneStep, HeadphoneCheckStep, HearingInNoisyPlacesStep, SetupPage, VolumeStep, SendResultsStep, } from '@/pages/setup-page.component';
import { WelcomePage } from '@/pages/welcome-page.component';
import { Navigate } from 'react-router-dom';
import { ModerateHearingLossResults } from '@/components/results-category/components/moderate-hearing-loss-results.component';
import { MildHearingLossResults } from '@/components/results-category/components/mild-hearing-loss-results.component';
import { NormalHearingLossResults } from '@/components/results-category/components/normal-hearing-loss-results.component';
import { InstructionsStep } from '@/components/hearing-test-instructions.component';
export var appRoutes = [
    { path: '/', element: _jsx(WelcomePage, {}) },
    {
        path: '/setup',
        element: _jsx(SetupPage, {}),
        children: [
            {
                index: true,
                element: _jsx(Navigate, { to: "/setup/hearing-in-noisy-places", replace: true }),
            },
            {
                path: 'hearing-in-noisy-places',
                element: _jsx(HearingInNoisyPlacesStep, {}),
            },
            { path: 'select-your-birth-year', element: _jsx(AgeStep, {}) },
            { path: 'send-your-results', element: _jsx(SendResultsStep, {}) },
            {
                path: 'confirm-headphone-connection',
                element: _jsx(ConnectHeadphoneStep, {}),
            },
            {
                path: 'headphone-check',
                element: _jsx(HeadphoneCheckStep, {}),
            },
            { path: 'volume', element: _jsx(VolumeStep, {}) },
        ],
    },
    { path: '/instructions', element: _jsx(InstructionsStep, {}) },
    { path: '/din-test', element: _jsx(Navigate, { to: "/din-test/1", replace: true }) },
    { path: '/din-test/:id', element: _jsx(DinTestPage, {}) },
    {
        path: '/result-category',
        element: _jsx(ResultCategoryPage, {}),
        children: [
            {
                path: 'moderate',
                element: _jsx(ResultCategoryOutlet, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(ModerateHearingLossResults, {}),
                    },
                ],
            },
            {
                path: 'mild',
                element: _jsx(ResultCategoryOutlet, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(MildHearingLossResults, {}),
                    },
                ],
            },
            {
                path: 'normal',
                element: _jsx(ResultCategoryOutlet, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(NormalHearingLossResults, {}),
                    },
                ],
            },
        ],
    },
    {
        path: '/index.html',
        element: _jsx(Navigate, { to: "/", replace: true }),
    },
];
